import injectCCConfig from "./ccConfig";

export default function injectGlobalDependecies(): void {
    injectCCConfig();
}
